module.exports = __webpack_public_path__ + "img/delete_1.1307a112.jpg";